import { Row } from "react-table";
import { DateFilterTypes } from "../constants";
import { applyCustomDateFilter, applyPresetDateFilter } from "./filterHelper";

const shipmentFilter = (rows: Array<Row<any>>, columnIds: Array<any>, globalFilterValue: any) => {
  let filteredRows: any = rows;

  filteredRows = globalSearchFilter(filteredRows, globalFilterValue);
  filteredRows = multiSelectFilter(filteredRows, globalFilterValue);
  filteredRows = dateFilter(filteredRows, globalFilterValue);
  filteredRows = textFilter(filteredRows, globalFilterValue);

  return filteredRows;
};

const globalSearchFilter = (rows: Array<Row<any>>, globalFilterValue: any) => {
  const query = globalFilterValue?.query?.toLowerCase() || '';

  if (!query) {
    return rows;
  }

  return rows.filter((row: any) => {
    const { original } = row;
    
    // Define properties to search in lowercase
    const searchableProperties = [
      'shipment_title',
      'shipment_reference',
      'payment_location',
      'created_by.name',
      'awarded_provider',
    ];

    // Check if any property contains the query string
    return searchableProperties.some(prop => {
      if (prop === 'created_by.name') {
        return original?.created_by?.name?.toLowerCase()?.includes(query);
      } 
      return original?.[prop]?.toLowerCase()?.includes(query);
    });
  });
};

const multiSelectFilter = (rows: Array<Row<any>>, globalFilterValue: any) => {
  let filteredRows = rows;
  if (globalFilterValue?.display_status?.length) {
    filteredRows = filteredRows.filter((row) =>
      globalFilterValue.display_status.includes(row.original?.display_status?.label),
    );
  }
  if (globalFilterValue?.payment_location?.length) {
    filteredRows = filteredRows.filter((row: any) =>
      globalFilterValue.payment_location.includes(row.original?.payment_location),
    );
  }
  if (globalFilterValue?.freight_mode?.length) {
    filteredRows = filteredRows.filter((row: any) => globalFilterValue.freight_mode.includes(row.original?.freight_mode));
  }
  if (globalFilterValue?.provider_team?.length) {
    filteredRows = filteredRows.filter((row: any) => globalFilterValue.provider_team.includes(row.original?.team_name));
  }
  if (globalFilterValue?.shipper?.length) {
    filteredRows = filteredRows.filter((row: any) => globalFilterValue.shipper.includes(row.original?.shipper));
  }
  return filteredRows;
};

const dateFilter = (rows: Array<Row<any>>, globalFilterValue: any) => {
  let filteredRows = rows;
  if (globalFilterValue?.requested_pickup_date?.type) {
    filteredRows = filteredRows.filter((row: any) => {
      if (globalFilterValue?.requested_pickup_date?.type === DateFilterTypes.CUSTOM) {
        return applyCustomDateFilter(row.original?.pickup_date, globalFilterValue.requested_pickup_date);
      }
      return applyPresetDateFilter(row.original?.pickup_date, globalFilterValue.requested_pickup_date);
    });
  }
  if (globalFilterValue?.quoted_pickup_date?.type) {
    filteredRows = filteredRows.filter((row: any) => {
      if (globalFilterValue?.quoted_pickup_date?.type === DateFilterTypes.CUSTOM) {
        return applyCustomDateFilter(row.original?.quoted_pickup_datetime, globalFilterValue.quoted_pickup_date);
      }
      return applyPresetDateFilter(row.original?.quoted_pickup_datetime, globalFilterValue.quoted_pickup_date);
    });
  }
  if (globalFilterValue?.expected_pickup_date?.type) {
    filteredRows = filteredRows.filter((row: any) => {
      if (globalFilterValue?.expected_pickup_date?.type === DateFilterTypes.CUSTOM) {
        return applyCustomDateFilter(row.original?.updated_pickup_datetime, globalFilterValue.expected_pickup_date);
      }
      return applyPresetDateFilter(row.original?.updated_pickup_datetime, globalFilterValue.expected_pickup_date);
    });
  }
  if (globalFilterValue?.requested_delivery_date?.type) {
    filteredRows = filteredRows.filter((row: any) => {
      if (globalFilterValue?.requested_delivery_date?.type === DateFilterTypes.CUSTOM) {
        return applyCustomDateFilter(row.original?.stop1_date, globalFilterValue.requested_delivery_date);
      }
      return applyPresetDateFilter(row.original?.stop1_date, globalFilterValue.requested_delivery_date);
    });
  }
  if (globalFilterValue?.quoted_delivery_date?.type) {
    filteredRows = filteredRows.filter((row: any) => {
      if (globalFilterValue?.quoted_delivery_date?.type === DateFilterTypes.CUSTOM) {
        return applyCustomDateFilter(row.original?.quoted_delivery_datetime, globalFilterValue.quoted_delivery_date);
      }
      return applyPresetDateFilter(row.original?.quoted_delivery_datetime, globalFilterValue.quoted_delivery_date);
    });
  }
  if (globalFilterValue?.expected_delivery_date?.type) {
    filteredRows = filteredRows.filter((row: any) => {
      if (globalFilterValue?.expected_delivery_date?.type === DateFilterTypes.CUSTOM) {
        return applyCustomDateFilter(row.original?.updated_delivery_datetime, globalFilterValue.expected_delivery_date);
      }
      return applyPresetDateFilter(row.original?.updated_delivery_datetime, globalFilterValue.expected_delivery_date);
    });
  }
  if (globalFilterValue?.pickup_date?.type) {
    filteredRows = filteredRows.filter((row: any) => {
      if (globalFilterValue?.pickup_date?.type === DateFilterTypes.CUSTOM) {
        return applyCustomDateFilter(row.original?.pickup_date, globalFilterValue.pickup_date);
      }
      return applyPresetDateFilter(row.original?.pickup_date, globalFilterValue.pickup_date);
    });
  }
  if (globalFilterValue?.delivery_date?.type) {
    filteredRows = filteredRows.filter((row: any) => {
      if (globalFilterValue?.delivery_date?.type === DateFilterTypes.CUSTOM) {
        return applyCustomDateFilter(row.original?.stop1_date, globalFilterValue.delivery_date);
      }
      return applyPresetDateFilter(row.original?.stop1_date, globalFilterValue.delivery_date);
    });
  }
  return filteredRows;
};

const textFilter = (rows: Array<Row<any>>, globalFilterValue: any) => {
  let filteredRows = rows;
  if (globalFilterValue?.pickup_city) {
    filteredRows = filteredRows.filter(
      (row: any) =>
        row.original?.pickup_city &&
        row.original.pickup_city?.toLowerCase()?.indexOf(globalFilterValue?.pickup_city?.toLowerCase()) !== -1,
    );
  }
  if (globalFilterValue?.pol_locode) {
    filteredRows = filteredRows.filter(
      (row: any) =>
        row.original?.pol_locode &&
        row.original.pol_locode?.toLowerCase()?.indexOf(globalFilterValue?.pol_locode?.toLowerCase()) !== -1,
    );
  }
  if (globalFilterValue?.delivery_city) {
    filteredRows = filteredRows.filter(
      (row: any) =>
        row.original?.stop1_city &&
        row.original.stop1_city?.toLowerCase()?.indexOf(globalFilterValue?.delivery_city?.toLowerCase()) !== -1,
    );
  }
  if (globalFilterValue?.pod_locode) {
    filteredRows = filteredRows.filter(
      (row: any) =>
        row.original?.pod_locode &&
        row.original.pod_locode?.toLowerCase()?.indexOf(globalFilterValue?.pod_locode?.toLowerCase()) !== -1,
    );
  }
  if (globalFilterValue?.created_by) {
    filteredRows = filteredRows.filter(
      (row: any) =>
        row.original?.created_by?.name &&
        row.original.created_by.name.toLowerCase()?.indexOf(globalFilterValue?.created_by?.toLowerCase()) !== -1,
    );
  }
  if (globalFilterValue?.awarded_provider) {
    filteredRows = filteredRows.filter(
      (row: any) =>
        row.original?.awarded_provider &&
        row.original.awarded_provider.toLowerCase()?.indexOf(globalFilterValue?.awarded_provider?.toLowerCase()) !== -1,
    );
  }
  if (globalFilterValue?.origin_name) {
    filteredRows = filteredRows.filter(
      (row: any) =>
        row.original?.origin?.origin_name &&
        row.original.origin?.origin_name.toLowerCase()?.indexOf(globalFilterValue?.origin_name?.toLowerCase()) !== -1,
    );
  }
  if (globalFilterValue?.destination_name) {
    filteredRows = filteredRows.filter(
      (row: any) =>
        row.original?.delivery?.destination_name &&
        row.original.delivery?.destination_name
          .toLowerCase()
          ?.indexOf(globalFilterValue?.destination_name?.toLowerCase()) !== -1,
    );
  }
  return filteredRows;
};

export default shipmentFilter;
